import axios from "axios";
import { APIURL } from "./../Constantes";
import { getCabecera } from "../utils/getCabecera";
import { getError } from "../utils/errors";
const urlPassenger = "Passenger";

//TODO: Cmabio de pasajeros
export const postPenalizacionAddPasajero = async ({ IdPaquete, Adultos, Menores, Infantes }) => {
  return await axios.post(`${APIURL}/${urlPassenger}/Change/Add/NewPrice`, {
    IdPaquete,
    Adultos,
    Menores,
    Infantes
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
export const postPasajeroAdd = async ({ IdPaquete, Adultos, Menores, Infantes }) => {
  return await axios.post(`${APIURL}/${urlPassenger}/Change/Request/Add`, {
    IdPaquete,
    Adultos,
    Menores,
    Infantes
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
export const getPasajeros = async ({ IdPaquete }) => {
  return await axios.get(`${APIURL}/${urlPassenger}/Change/${IdPaquete}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return {};
  })
}
export const getSolicitudesPasajeros = async ({ IdPaquete }) => {
  return await axios.get(`${APIURL}/${urlPassenger}/Change/Add/Availability/${IdPaquete}`, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return {};
  })
} 
export const putPasajeroAcept = async ({ IdSolicitud }) => {
  return await axios.put(`${APIURL}/${urlPassenger}/Change/Add/Acept/Agent/${IdSolicitud}`, {
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
export const putPasajeroDecline = async ({ IdSolicitud }) => {
  return await axios.put(`${APIURL}/${urlPassenger}/Change/Add/Decline/Agent/${IdSolicitud}`, {
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
export const postPenalizacionDeletePasajero = async ({ IdPaquete, Adultos, Menores, Infantes }) => {
  return await axios.post(`${APIURL}/${urlPassenger}/Change/Remove/Penalty`, {
    IdPaquete,
    Adultos,
    Menores,
    Infantes
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}
export const putPsajeroDelete = async ({ IdPaquete, Adultos, Menores, Infantes }) => {
  return await axios.put(`${APIURL}/${urlPassenger}/Change/Remove/${IdPaquete}`, {
    IdPaquete,
    Adultos,
    Menores,
    Infantes
  }, {
    headers: getCabecera()
  }).then((Response) => {
    return Response.data;
  }).catch((Error) => {
    return getError(Error);
  })
}

//**Nuevo metodos para el check in de los cleintes */
export const getPasajeroAll = async ({ IdPaquete }) => {
  return await axios.get(`${APIURL}/${urlPassenger}/CheckIn/${IdPaquete}`, {
      headers: getCabecera()
  })
      .then(Response => {
          return Response.data
      })
      .catch(Error => {
          getError(Error)
          return []
      })
}

export const updatePasajeroInfo = async ({ IdPasajero, IdPaquete, idCuenta, IdCatTipoPasajero, Nombre, ApellidoPaterno, ApellidoMaterno, Nacionalidad, Internacional, NumeroPasaporte, FechaVencimiento, FechaNacimiento }) => {
  return await axios.put(`${APIURL}/${urlPassenger}/${IdPasajero}/${IdPaquete}`, {
      "idCuenta": idCuenta,
      "IdCatTipoPasajero": IdCatTipoPasajero,
      "Nombre": Nombre,
      "ApellidoPaterno": ApellidoPaterno,
      "ApellidoMaterno": ApellidoMaterno,
      "Nacionalidad": Nacionalidad,
      "Internacional": Internacional,
      "FechaNacimiento": FechaNacimiento,
      "Pasaporte": {
          "NumeroPasaporte": NumeroPasaporte,
          "FechaVencimiento": FechaVencimiento
      }
  }, {
      headers: getCabecera()
  })
      .then((Response) => {
          return Response;
      })
      .catch((Error) => {
          return getError(Error);
      })
}